import {
  isWorkspaceAgentSessionRunning,
  type WorkspaceAgentSessionRunningState,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/isWorkspaceAgentSessionRunning';

export type WorkspaceAgentPanelHeaderStatus = 'waiting' | 'working' | 'idle';

export type WorkspaceAgentPanelHeaderStatusInput = WorkspaceAgentSessionRunningState & {
  hasPendingElicitations: boolean;
};

export const getWorkspaceAgentPanelHeaderStatus = ({
  activeRunId,
  hasPendingElicitations,
  isAwaitingRunStart,
  isSending,
  isSessionProcessing,
}: WorkspaceAgentPanelHeaderStatusInput): WorkspaceAgentPanelHeaderStatus => {
  if (hasPendingElicitations) {
    return 'waiting';
  }

  if (
    isWorkspaceAgentSessionRunning({
      activeRunId,
      isAwaitingRunStart,
      isSending,
      isSessionProcessing,
    })
  ) {
    return 'working';
  }

  return 'idle';
};
